import React from 'react';
import { ComponentType } from 'src/types/SCADA/componentsTypes';
import { RotorElement } from '../../generalComponents/rotorElement/RotorElement';
import { SubmersiblePump } from '../../assetComponents';
import { SpinningPump } from '../../assetComponents/spinningPump';
import { RegularPump } from '../../assetComponents/regularPump';

type Props = {
  type: ComponentType;
  isRunning: boolean;
  isAlarmActive: boolean;
  width?: number;
  height?: number;
};

export const PumpWidgetIcon: React.FC<Props> = React.memo(
  ({ type, isRunning, isAlarmActive, width, height }) => {
    if (type === ComponentType.Rotor) {
      return (
        <RotorElement
          width={width}
          height={height}
          isRunning={isRunning}
          isAlarmActive={isAlarmActive}
        />
      );
    }
    if (type === ComponentType.SubmersiblePump) {
      return (
        <SubmersiblePump
          width={width}
          height={height}
          isAlarmActive={isAlarmActive}
          isRunning={isRunning}
        />
      );
    }
    if (type === ComponentType.SpinningPump) {
      return (
        <SpinningPump
          width={width}
          height={height}
          isAlarmActive={isAlarmActive}
          isRunning={isRunning}
        />
      );
    }
    if (type === ComponentType.Pump) {
      return (
        <RegularPump
          width={width}
          height={height}
          isAlarmActive={isAlarmActive}
          isRunning={isRunning}
        />
      );
    }
    return null;
  }
);
